import React, { useEffect, useState } from "react";
import { Form, Input, notification, Select, Space, Upload, Button, Image, TextArea } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { GrUpload } from "react-icons/gr";
import { MinusCircleOutlined, PlusOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import CategoryRequest from "./CategoryRequest";
import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UpdateServices = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [serviceDetails, setServiceDetails] = useState({});
  const { id } = useParams();
  const [submited, setSubmit] = useState(false);

  const update=()=>{
    setSubmit(true);
  }

  useEffect(() => {
    const getServiceDetails = async () => {
      setLoading(true)

      try {
        const res = await CategoryRequest.serviceDetails(id)
        const serviceData = res?.data?.data
        console.log("serviceData", serviceData)

        if (serviceData) {
          const mappedData = {
            ...serviceData,
            status: serviceData.status === 1 ? "1" : "0",
          };
          setServiceDetails(mappedData)
          console.log("setServiceDetails", setServiceDetails)

          form.setFieldsValue({
            title: mappedData.title,
            status: mappedData.status,
            description: mappedData.description,
            includedServices: mappedData.includedServices || [],
            uses: mappedData.uses,
            whatsIncluded: mappedData.whatsIncluded || [],
          });
          if (mappedData.serviceImage) {
            setFileList([{ url: mappedData.serviceImage, name: "Uploaded Image" }]);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    if (id) getServiceDetails();
  }, [id, form]);

  const onFinish = (values) => {
    console.log("Form values:", values);
    if(submited)
      { setLoading(true);
    const formData = { ...values, id };
    CategoryRequest.updateService(formData)
      .then((res) => {
        console.log("API response:", res);
        if (res.status === 200) {
          notification["success"]({
            message: "Service updated successfully",
          });
          navigate(-1, { state: { refresh: true } });
        } else {
          notification["error"]({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "Failed",
        });
      });
    }
  };



  const imageUpload = (file, name) => {
    setLoading(true);

    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    CategoryRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          serviceImage: res?.data?.uploadDirectory,
        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };

  // const props = {
  //   name: "file",
  //   multiple: false,
  //   beforeUpload: (file) => {

  //     imageUpload(file, file.name);
  //     return false;
  //   },
  //   onRemove() {
  //     setFileList([]);
  //   },
  // };

    const props = {
      name: "file",
      multiple: false,
      accept : "image/*",
      beforeUpload: (file) => {
        const isImage = file.type.startsWith("image/");
        if(!isImage){
          notification.error({
            message : "Invalid file type",
            description : "Only image files are allowed (jpg, png, jpeg, webp)",
          });
          return Upload.LIST_IGNORE; 
        }
        imageUpload(file, file.name);
        return false;
      },
      onRemove() {
        setFileList([]);
      },
    };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const uploadButton = (
    <button style={{ border: 0, background: "none" }}>
      <GrUpload />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  return (
    <section>
      <div className="Create-Category">
        <Form form={form}
          onFinish={onFinish}
          layout="vertical"
          initialValues={null}
          className="subscription-form"
          colon={true}
        >
          <Form.Item className="submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Update Service</h3>

          <div className="subscription">
            <div className="subscription-plan">
              <Form.Item
                name="title"
                label=" Name"
                rules={[{ required: true, message: "Please enter the service name" },
                {
                  pattern: /^[A-Za-z\s]+$/,
                  message: "service name can only contain alphabetic characters!",
                },
                ]}
              >
                <Input size="large" placeholder="Enter Service Name" />
              </Form.Item>
            </div>


            <Form.Item
              label="Status"
              name="status"
              className="subscription-plan"
              rules={[{ required: true, message: "Please select the service status!" }]}
            >
              <Select
                placeholder="Select The service Status"
       
                options={[
                  { value: "1", label: "Active" },
                  { value: "0", label: "Inactive" },
                ]}
              />
            </Form.Item>

          </div>

          <div className="subscription">
            <div className="subscription-plan">

              <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true, message: "Please enter the description" },
                {
                  pattern: /^[A-Za-z0-9\s]+$/,
                  message: "service name can only contain alphabetic characters!",
                },
                ]}
              >
                <Input size="large" placeholder="Description" />
              </Form.Item>

            </div>
            <div className="subscription-plan">
              {/* <Form.Item
                name="uses"
                label="Uses"
                rules={[{ required: true, message: "Please enter the uses" },
                {
                  pattern: /^[A-Za-z\s]+$/,
                  message: "Category name can only contain alphabetic characters!",
                },
                ]}
              >
                <Input size="large" placeholder="Uses" />
              </Form.Item> */}

              {/* <div style={{ flex: 1 }}>
                            <Form.List name="uses">
                              {(fields, { add, remove }) => (
                                <div className="AddTextField">
                                  <label>Uses</label>
                                  {fields.map((field) => (
                                    <Form.Item key={field.key} required>
                                      <Form.Item {...field} noStyle
                                        rules={[
                                          {
                                            pattern: /^[A-Za-z\s]+$/,
                                            message: "Please enter only alphabetic characters!",
                                          },
                                        ]}>
                                        <Input.TextArea placeholder="Enter the uses" autoSize />
                                      </Form.Item>
                                      {fields.length > 1 && (
                                        <MinusCircleOutlined onClick={() => remove(field.name)} />
                                      )}
                                    </Form.Item>
                                  ))}
                                  <Form.Item>
                                    <Button type="dashed" onClick={() => add()}>
                                      <PlusOutlined /> Add Field
                                    </Button>
                                  </Form.Item>
                                </div>
                              )}
                            </Form.List>
                          </div> */}
            </div>
          </div>

          {/* <div style={{ display: "flex", justifyContent: "space-between", gap: "3rem" }}>
            <div style={{ flex: 1 }}>
              <Form.List name="includedServices">
                {(fields, { add, remove }) => (
                  <div className="AddTextField">
                    <label>Services Includes</label>
                    {fields.map((field) => (
                      <Form.Item key={field.key} required>
                        <Form.Item {...field} noStyle 
                        rules={[
                          {
                            pattern: /^[A-Za-z\s]+$/,
                            message: "Please enter only alphabetic characters!",
                          },
                        ]}>
                          <Input.TextArea placeholder="Enter the details about Includes Services" autoSize />
                        </Form.Item>
                        {fields.length > 1 && (
                          <MinusCircleOutlined onClick={() => remove(field.name)} />
                        )}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button type="dashed" onClick={() => add()}>
                        <PlusOutlined /> Add Field
                      </Button>
                    </Form.Item>
                  </div>
                )}
              </Form.List>
            </div>

            <div style={{ flex: 1 }}>

              <Form.List name="whatsInclude">
                {(fields, { add, remove }) => (
                  <div className="AddTextField">
                    <label>what Included</label>
                    {fields.map((field) => (
                      <Form.Item key={field.key} required>
                        <Form.Item {...field} noStyle 
                        rules={[
                          {
                            pattern: /^[A-Za-z\s]+$/,
                            message: "Please enter only alphabetic characters!",
                          },
                        ]}>
                          <Input.TextArea placeholder="Enter the details about what  includes" autoSize />
                        </Form.Item>
                        {fields.length > 1 && (
                          <MinusCircleOutlined onClick={() => remove(field.name)} />
                        )}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button type="dashed" onClick={() => add()}>
                        <PlusOutlined /> Add Field
                      </Button>
                    </Form.Item>
                  </div>
                )}
              </Form.List>

            </div>
          </div> */}

          <Form.Item name="serviceImage" label="Service Image" style={{ marginTop: "2rem" }}>
            <Upload
              {...props} maxCount={1}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleImageChange}
            >
              {fileList.length >= 8 ? null : uploadButton}
            </Upload>
            {previewImage && (
              <Image
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                }}
                src={previewImage}
              />
            )}
          </Form.Item>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" htmlType="submit" loading={loading} onClick={update} >
                Submit
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default UpdateServices;
